import { render, staticRenderFns } from "./ColorInputForm.vue?vue&type=template&id=7234eb40&"
import script from "./ColorInputForm.vue?vue&type=script&lang=js&"
export * from "./ColorInputForm.vue?vue&type=script&lang=js&"
import style0 from "./ColorInputForm.vue?vue&type=style&index=0&lang=scss&scpoed=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports